<ion-header>
  <ion-toolbar>
    <ion-buttons slot="secondary">
      <ion-button (click)="onClose()">Close</ion-button>
    </ion-buttons>
    <ion-title></ion-title>
  </ion-toolbar>
  <app-impersonation-banner></app-impersonation-banner>
  <app-upload-manager></app-upload-manager>
</ion-header>

<ion-content>
  <ion-grid [fixed]="true">
    <ion-row>
      <ion-col size="12">
        <h1>Unlock Full Access</h1>

        <div class="lp-margin-bottom-24">
          <ul class="lp-padding-start-18 lp-margin-vertical-none lp-font-size-14">
            <li>Add memories of significant life moments.</li>
            <li>Organize important documents in a secure location.</li>
            <li>Answer questions on how you envision your life to be celebrated.</li>
            <li>Include family information to facilitate efficient communication.</li>
            <li>Designate specific contacts to ensure your wishes are honored.</li>
          </ul>
        </div>

        @if (products.length > 0) {
          <ion-radio-group value="" (ionChange)="onSubscriptionChange($event)">
            @for (product of products; track product.identifier; let i = $index) {
              <ion-item class="lp-margin-vertical-16 radio-group" lines="none" [button]="false">
                <div slot="start">
                  <ion-radio value="{{ product.identifier }}">
                    <div slot="container">
                      <ion-icon
                        name="checkmark"
                        size="large"
                        slot="icon"
                        class="ion-text-primary"></ion-icon>
                    </div>
                  </ion-radio>
                </div>

                <ion-label class="lp-margin-vertical-16">
                  <h2>{{ product.title }}</h2>

                  <div class="lp-margin-top-4">
                    @if (product.subscriptionPeriod?.periodDuration === 'P1Y') {
                      <div>
                        <ion-text class="lp-font-size-12">
                          12 mo -
                          {{ product.subscriptionPeriod?.pricePerMonth?.formattedPrice }}
                        </ion-text>
                      </div>
                    } @else {
                      <div>
                        <ion-text class="lp-font-size-12">
                          {{ product.subscriptionPeriod?.period?.number }}
                          {{ getProductUnitAbbreviation(product.subscriptionPeriod?.period) }} -
                          {{ product.subscriptionPeriod?.pricePerMonth?.formattedPrice }}
                        </ion-text>
                      </div>
                    }
                  </div>
                </ion-label>

                <div slot="end">
                  <ion-text class="lp-font-size-20 lp-font-weight-500">
                    {{ product.currentPrice.formattedPrice }}/{{
                      getProductUnitAbbreviation(product.subscriptionPeriod?.period)
                    }}
                  </ion-text>
                </div>
              </ion-item>
            }
          </ion-radio-group>
        } @else {
          <ion-radio-group>
            @for (item of [].constructor(2); track $index; let i = $index) {
              <ion-item class="lp-margin-vertical-16 radio-group" lines="none" [button]="false">
                <div slot="start">
                  <ion-radio [disabled]="true" value="{{ i }}">
                    <div slot="container">
                      <ion-icon
                        name="checkmark"
                        size="large"
                        slot="icon"
                        class="ion-text-primary"></ion-icon>
                    </div>
                  </ion-radio>
                </div>
                <ion-label class="lp-margin-vertical-16">
                  <h2>
                    <ion-skeleton-text [animated]="true" style="width: 80%"></ion-skeleton-text>
                  </h2>

                  <div class="lp-margin-top-4">
                    <ion-text class="lp-font-size-12">
                      <ion-skeleton-text [animated]="true" style="width: 60%"></ion-skeleton-text>
                    </ion-text>
                  </div>
                </ion-label>
                <div slot="end">
                  <ion-text class="lp-font-size-20 lp-font-weight-500">
                    <ion-skeleton-text [animated]="true" style="width: 80px"></ion-skeleton-text>
                  </ion-text>
                </div>
              </ion-item>
            }
          </ion-radio-group>
        }

        <div class="ion-text-center lp-margin-vertical-30">
          <div class="lp-margin-bottom-30">
            <ion-button color="primary" size="default" expand="block" (click)="onPurchaseProduct()">
              {{ buttonIntroductoryOfferCopy() }}
            </ion-button>
          </div>
          <div class="lp-margin-bottom-16">
            <ion-button
              class="lp-button-link"
              color="primary"
              fill="clear"
              size="default"
              (click)="onPrivacyPolicyClick()">
              Privacy Policy
            </ion-button>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
